/** Sync endpoints. */
import { api } from '@/lib/api/client';
import type { PullResponse, PushRequest, PushResponse } from '@/lib/api/types';

export type SyncApi = {
  push: (body: PushRequest, idempotencyKey: string) => Promise<PushResponse>;
  pull: (projectId: string, cursor: string | null, limit: number) => Promise<PullResponse>;
};

export const syncApi: SyncApi = {
  async push(body, idempotencyKey) {
    const response = await api.post<PushResponse>('/sync/push', body, { idempotencyKey });
    return response.data;
  },
  async pull(projectId, cursor, limit) {
    const response = await api.get<PullResponse>('/sync/pull', {
      query: { project_id: projectId, cursor, limit },
    });
    return response.data;
  },
};
